import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';

export const UpdateDobCarrierStep: Step = {
  id: 'updatedobcarrier',
  pathname: '/updatedobcarrier',
  canShow: (appData: AppData) => !!appData.updateDobChallenge,
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Account,
};
